export const selectCarePlanSteps = [
  {
    element: '#choosecareplan',
    popover: {
      title: 'Choose a Care Plan ',
      showButtons: ['next', 'close'],
      description:
        '<div><ul><li> A list of plans appears (e.g., CAREPLAN‐A). Select one to see its description and included devices.</li> </ul></div>',
    },
  },

  {
    element: '#selectedplanpreview',
    popover: {
      title: ' Assigned Plan Preview ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li> Confirm on the right which plan and devices have been assigned.</li><li>Click Add Devices to add more devices if needed.</li></ul></div>',
    },
  },
  {
    element: '#gotoschedule',
    popover: {
      title: 'Move to Device Scheduling ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>Click Next to set up device schedules.</li></ul></div>',
    },
  },
]
export const deviceScheduleSteps = [
  {
    element: '#decschedcard',
    popover: {
      title: 'Review & Edit Device Schedules ',
      showButtons: ['next', 'close'],
      description:
        '<div><ul><li> Each device (e.g., Peak Flow Meter) shows start/end dates and frequency (e.g., daily).</li><li>Click the pencil icon to edit schedule details.</li> </ul></div>',
    },
  },

  {
    element: '#adddevice',
    popover: {
      title: ' Add Devices ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li> Click Add Devices to include more measurement devices. </li></ul></div>',
    },
  },
  {
    element: '#editdevice',
    popover: {
      title: ' Edit Devices Schedule ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li> Click the pencil icon to edit schedule details. </li></ul></div>',
    },
  },
  {
    element: '#deletedevice',
    popover: {
      title: 'Remove Devices ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li> Click the trash icon to remove any device.</li></ul></div>',
    },
  },
  {
    element: '#savedevsched',
    popover: {
      title: ' Complete Patient Setup',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li> Click Next to save all device schedule details and continue.</li></ul></div>',
    },
  },
]

export const regimenScheduleSteps = [
  {
    element: '#selectregimen',
    popover: {
      title: 'Select the Appropriate Regimen ',
      showButtons: ['next', 'close'],
      description:
        '<div><ul><li> A regimen list appears for the relevant surgery type (e.g., Knee). </li><li> Choose or confirm which exercise regimen applies.</li> </ul></div>',
    },
  },

  {
    element: '#selectedregimenview',
    popover: {
      title: 'Assigned Regimen Preview',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>On the right, you’ll see the assigned regimen with its exercises.</li></ul></div>',
    },
  },
  {
    element: '#saveregimen',
    popover: {
      title: 'Continue to Exercise Schedule',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>Click Next to proceed once you’ve confirmed the regimen.</li></ul></div>',
    },
  },
]

export const exeScheduleSteps = [
  {
    element: '#exeschedview',
    popover: {
      title: ' View Assigned Exercises',
      showButtons: ['next', 'close'],
      description:
        '<div><ul><li> Each exercise displays config details (hold time, repeats, sets).</li> </ul></div>',
    },
  },

  {
    element: '#editexe',
    popover: {
      title: 'Adjust Schedules',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>In the Schedule column, verify or edit start/end dates and frequency.</li><li>Use the pencil icon to modify scheduling.</li></ul></div>',
    },
  },
  {
    element: '#deleteexe',
    popover: {
      title: 'Remove Exercise ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li> Use the trash icon to delete any exercise. </li></ul></div>',
    },
  },
  {
    element: '#addexe',
    popover: {
      title: 'Add Exercise',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>Click Add Exercise to add more.</li></ul></div>',
    },
  },
  {
    element: '#saveexesched',
    popover: {
      title: 'Proceed to Questionnaires ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>Click Next when you’re done with exercise scheduling.</li></ul></div>',
    },
  },
]

export const feedScheduleSteps = [
  {
    element: '#feedschedview',
    popover: {
      title: 'Preview Questionnaires ',
      showButtons: ['next', 'close'],
      description:
        '<div><ul><li>Forms like “Functional Knee” or “Pain Management” can be previewed.</li> </ul></div>',
    },
  },

  {
    element: '#feedschedcardview',
    popover: {
      title: 'Check or Edit Schedules',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>Each questionnaire’s schedule (S-7, S+3, etc.) can be edited with the pencil icon.</li></ul></div>',
    },
  },
  {
    element: '#deleteform',
    popover: {
      title: ' Remove Forms ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li> Click the trash icon to remove any form.</li></ul></div>',
    },
  },
  {
    element: '#addform',
    popover: {
      title: ' Add Forms ',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li> Click Add Form to include more questionnaires.</li></ul></div>',
    },
  },
  {
    element: '#saverpatient',
    popover: {
      title: 'Finish Creating Patient',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><ul><li>Click Create (or Next, then Create) to finalize.</li><li>A popup may confirm device orders or shipments for the new patient.</li></ul></div>',
    },
  },
]
